import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaLicitacao: [],
    removeAguardandoAberturaConsultaLicitacao: [],
    removeTipoCompraConsultaLicitacao: [],
    removeExercicioLicitacaoConsultaLicitacao: [],
    removeNumeroLicitacaoConsultaLicitacao: [],
    removeModalidadeConsultaLicitacao: [],
    removeObjetoConsultaLicitacao: [],
    removeDataAberturaInicialConsultaLicitacao: [],
    removeDataAberturaFinalConsultaLicitacao: [],
    removeDataPublicacaoInicialConsultaLicitacao: [],
    removeDataPublicacaoFinalConsultaLicitacao: [],
    removeObjetoLicitacaoConsultaLicitacao: [],
    removeStatusConsultaLicitacao: [],
    removeSituacaoPesquisaConsultaLicitacao: [],
    setMostraAplicarFiltroConsultaLicitacao: [],
    limpaFiltroConsultaLicitacao: [],
    aplicarFiltroConsultaLicitacao: ['filtro'],
})

const INITIAL_STATE = {
    administracoes: '',
    aguardandoAbertura: '',
    tipoCompra: '',
    exercicioLicitacao: '',
    numeroLicitacao: '',
    modalidade: [],
    objeto: '',
    dataAberturaInicial: '',
    dataAberturaFinal: '',
    dataPublicacaoInicial: '',
    dataPublicacaoFinal: '',
    objetoLicitacao: [],
    situacaoPesquisa: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracoes.splice(state.administracoes.indexOf(action.administracoes), 1)
    state.administracoes = Array.from(state.administracoes)
    return { ...state, mostraAplicarFiltro: true }
}

const removeObjetoLicitacao = (state = INITIAL_STATE, action) => {
    state.objetoLicitacao.splice(state.objetoLicitacao.indexOf(action.objetoLicitacao), 1)
    state.objetoLicitacao = Array.from(state.objetoLicitacao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeAguardandoAbertura = (state = INITIAL_STATE, action) => {
    return { ...state, aguardandoAbertura: '', mostraAplicarFiltro: true }
}

const removeTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: '', mostraAplicarFiltro: true }
}

const removeExercicioLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacao: '', mostraAplicarFiltro: true }
}

const removeNumeroLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacao: '', mostraAplicarFiltro: true }
}

const removeModalidade = (state = INITIAL_STATE, action) => {
    state.modalidade.splice(state.modalidade.indexOf(action.modalidade), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.modalidade = Array.from(state.modalidade)
    return { ...state, mostraAplicarFiltro: true }
}

const removeObjeto = (state = INITIAL_STATE, action) => {
    return { ...state, objeto: '', mostraAplicarFiltro: true }
}

const removeDataAberturaInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataAberturaInicial: '', mostraAplicarFiltro: true }
}

const removeDataAberturaFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataAberturaFinal: '', mostraAplicarFiltro: true }
}

const removeDataPublicacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataPublicacaoInicial: '', mostraAplicarFiltro: true }
}

const removeDataPublicacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataPublicacaoFinal: '', mostraAplicarFiltro: true }
}

const removeSituacaoPesquisaFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, situacaoPesquisa: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_LICITACAO]: removeAdministracao,
    [Types.REMOVE_OBJETO_LICITACAO_CONSULTA_LICITACAO]: removeObjetoLicitacao,
    [Types.REMOVE_AGUARDANDO_ABERTURA_CONSULTA_LICITACAO]: removeAguardandoAbertura,
    [Types.REMOVE_TIPO_COMPRA_CONSULTA_LICITACAO]: removeTipoCompra,
    [Types.REMOVE_EXERCICIO_LICITACAO_CONSULTA_LICITACAO]: removeExercicioLicitacao,
    [Types.REMOVE_NUMERO_LICITACAO_CONSULTA_LICITACAO]: removeNumeroLicitacao,
    [Types.REMOVE_MODALIDADE_CONSULTA_LICITACAO]: removeModalidade,
    [Types.REMOVE_OBJETO_CONSULTA_LICITACAO]: removeObjeto,
    [Types.REMOVE_DATA_ABERTURA_INICIAL_CONSULTA_LICITACAO]: removeDataAberturaInicial,
    [Types.REMOVE_DATA_ABERTURA_FINAL_CONSULTA_LICITACAO]: removeDataAberturaFinal,
    [Types.REMOVE_DATA_PUBLICACAO_INICIAL_CONSULTA_LICITACAO]: removeDataPublicacaoInicial,
    [Types.REMOVE_DATA_PUBLICACAO_FINAL_CONSULTA_LICITACAO]: removeDataPublicacaoFinal,
    [Types.REMOVE_SITUACAO_PESQUISA_CONSULTA_LICITACAO]: removeSituacaoPesquisaFiltro,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_LICITACAO]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_LICITACAO]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_LICITACAO]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_LICITACAO]: aplicarFiltro,
})
